document.addEventListener("DOMContentLoaded", () => {

    // CART JS
    if (window.Swiper) {
        let swiper = new Swiper('.swiper-recommended-products', {
            direction: 'horizontal',
            spaceBetween: 40,
            pagination: {
              el: '.swiper-pagination',
            },
            navigation: {
              nextEl: '.swiper-button-next-recommended-products',
              prevEl: '.swiper-button-prev-recommended-products',
            }
        })
        
        document.addEventListener('drawerOpen', () => {
            setTimeout(function(){
                removeButtons()
                updateSlider(swiper)
                accessoryButtons(swiper)
            }, 1000);
        })
    
        document.addEventListener('cart:updated', () => {
            setTimeout(function(){
                cartQuantity()
                updateSlider(swiper)
                removeButtons()
            }, 1000);
        })
    
        document.addEventListener('ajaxProduct:added', () => {
            setTimeout(function(){
                cartQuantity()
                updateSlider(swiper)
                removeButtons()
            }, 1000);
        })
    }

    // ADD CART ITEM AJAX/LOGIC
    async function addItemToCart(product) {
        if (!this.updating) this.updating = product;

        try {
            const response = await fetch(`${window.location.origin}/cart/add.js`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(product)
            });
    
            if (response.status === 200) {
                const {item_count, items, total_price} = await response.json();
                this.count = item_count;
                this.items = items;
                this._total = total_price;
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'))
            }
        } catch (err) {
            console.log(err);
        }
        
        this.updating = false;
    }

    // REMOVE CART ITEM AJAX/LOGIC
    async function update(updates) {
        if (!this.updating) this.updating = updates;
    
        try {
            const response = await fetch(`${window.location.origin}/cart/update.js`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(updates)
            });
    
            if (response.status === 200) {
                const {item_count, items, total_price} = await response.json();
                this.count = item_count;
                this.items = items;
                this._total = total_price;
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'))
            }
        } catch (err) {
            console.log(err);
        }
    
        this.updating = false;
    }

    // GET CART QUANTITY AJAX/LOGIC
    async function cartQuantity() {
        try {
            const response = await fetch(`${window.location.origin}/cart/update.js`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    
            if (response.status === 200) {
                const {item_count} = await response.json();
                updateCartCount(item_count)
            }

        } catch (err) {
            console.log(err);
        }
    }

    // GET CART ITEMS
    async function cartItems() {
        try {
            const response = await fetch(`${window.location.origin}/cart.js`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    
            if (response.status === 200) {
                const {items} = await response.json();
                return items
            }

        } catch (err) {
            console.log(err);
        }
    }

    // REMOVE ITEM FROM CART
    function removeButtons() {
        let removeButtons = document.querySelectorAll('.td-cart-quantity__button--remove')
        if (removeButtons.length > 0) {
            removeButtons.forEach((button) => { 
                button.addEventListener('click', (e) => {
                    e.preventDefault()
                    let line = (e.target.dataset.variant).toString()
                    update({ updates: {[line]: 0} })
                })
            })
        }
    }

    // ADD ITEM FROM ACCESSORY SLIDER
    function accessoryButtons(swiper) {
        let accessoriesButtons = document.querySelectorAll('.td-recommended-products__button')
        if (accessoriesButtons.length > 0) {
            accessoriesButtons.forEach((button) => { 
                button.addEventListener('click', (e) => {
                    e.preventDefault()
                    let productID = e.target.dataset.productid
                    addItemToCart({ id: productID, quantity: 1})
                    swiper.removeSlide(swiper.realIndex)
                    if (swiper.slides.length == 0) {
                        let container = document.querySelector('.td-cart__recommended-products')
                        if (container) {
                            container.style.display = 'none'; 
                        }
                    }
                    e.stopPropagation()
                })
            })
        }
    }

    // UPDATE CART COUNT
    function updateCartCount(count) {
        let topCount = document.querySelector('.td-cart-top__item-total')
        let totalCount = document.querySelector('.td-cart-items[data-count]')
        let bottomCount = document.querySelector('.td-cart-bottom__item-total')

        if (totalCount) {
            let realCount = totalCount.dataset.count
            if (realCount == 0 && topCount) {
                topCount.textContent = "Your cart is empty"
            } else { topCount.textContent = "Your cart (" + realCount + ")" }
            if (realCount < 2 && bottomCount) {
                bottomCount.textContent = "Subtotal (" + realCount + " Item)"
            } else { bottomCount.textContent = "Subtotal (" + realCount + " Items)" }
        }
    }

    // CHECKS CART ITEMS AND COMPARES IT TO SLIDER
    function updateSlider(swiper) {
        cartItems().then((items) => {
            items.forEach((item) => {
                let allSlides = swiper.slides;
                let currentTitle = item.product_title

                if ((currentTitle) && (allSlides.length > 0)) {

                    // REMOVE SLIDES
                    for (let i = 0; i < allSlides.length; i++) {
                        if (currentTitle == allSlides[i].dataset.productName) {
                            swiper.removeSlide(i)
                        }
                    }

                    if (swiper.slides.length == 0) {
                        let container = document.querySelector('.td-cart__recommended-products')
                        if (container) {
                            container.style.display = 'none'; 
                        }
                    }
                }

                if (allSlides.length < 1) {
                    let container = document.querySelector('.td-cart__recommended-products')
                    if (container) {
                        container.style.display = 'none'; 
                    }
                }
            })
        })
    }
});